export const booleanOptions = [
  { value: 2, label: '否' },
  { value: 1, label: '是' }
];

export default {

};
